import React, { useEffect, useState } from "react";
import StepContent from "../../components/step-content";
import { PlanType } from "../../components/enums/plan-type";
import { useSelector } from "react-redux";
import { StructuredListSkeleton } from "carbon-components-react";
import DisabilityPlanDetails from "./disability-plan-details";
import { formatCurrency } from "../../components/formatters";

const Disability = ({ pageStep }) => {
  const enrollments = useSelector(s => s.enrollments);
  const [shortTerm, setShortTerm] = useState();
  const [longTerm, setLongTerm] = useState();
  const [benefitGroup, setBenefitGroup] = useState();

  useEffect(() => {
    if (!Array.isArray(enrollments)) {
      var shortEnrollment = enrollments.selections.find(s => s.planType === PlanType.ShortTermDisability);
      if(shortEnrollment?.paycheckDeduction)
      setShortTerm(shortEnrollment?.paycheckDeduction);
      else {
        setShortTerm(enrollments?.shortTermDisability);
      }
      var longEnrollment = enrollments.selections.find(s => s.planType === PlanType.LongTermDisability);
      if(longEnrollment?.paycheckDeduction)
        setLongTerm(longEnrollment?.paycheckDeduction);
      else {
        setLongTerm(enrollments?.longTermDisability);
      }
      setBenefitGroup(enrollments?.employee.benefitGroup);

    }
  }, [enrollments]);

  const onSubmit = async (formData) => {
    console.log(formData);
  };


  return (
    <>
      <StepContent pageStep={pageStep} onSubmit={onSubmit} >
      <div className="flex flex-col sm:flex-row items-center mb-4 mt-2">
          <div className="text-3xl sm:mr-16">Disability</div>
          {/*
          <div className="sm:mr-16"><DisabilityPlanDetails benefitGroup={benefitGroup} /></div>
  */}
        </div>
        <p className="text-sm">
          Long-term and short-term disability are after tax payroll deductions so there is no tax impact if/when the benefit is utilized.  <br />
          These are not voluntary and all eligible employees are auto-enrolled.
        </p>
        {!Array.isArray(enrollments) ? <>
        <div className='text-2xl text-danger mt-4 mb-2'>Short-Term Disability</div>
        <div>Weekly paycheck deduction: <strong>{formatCurrency(shortTerm, 2)}</strong></div>
        <div className='text-2xl text-danger mt-4 mb-2'>Long-Term Disability</div>
        <div className="mb-4">Weekly paycheck deduction: <strong> {formatCurrency(longTerm, 2)}</strong></div>
        </> :
                <StructuredListSkeleton />
        }
      </StepContent>
    </>
  );
};

export default Disability;
